<template>
    <el-dialog :visible.sync="isQueryHot" :before-close="handleClose" title="视频热度查询" class="withDrawal"
        v-loading="loading" width="1400px">
        <div class="action-bar">
            <el-input v-model="params.keyword" placeholder="请输入关键字" clearable @keyup.enter.native="getVideoList('status')"
                size="small" class="param-input"></el-input>
            <el-button type="primary" size="small" @click="getVideoList()">搜索</el-button>
        </div>
        <!--数据表格-->
        <el-table :data="tableData" style="width: 100%" border ref="multipleTable" v-loading="loading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" height="580">
            <el-table-column prop="id" label="视频ID" align="center" min-width="220"></el-table-column>
            <el-table-column prop="publisherID" label="发布者ID" align="center" min-width="140"></el-table-column>
            <el-table-column prop="title" label="视频标题" align="center" :show-overflow-tooltip="true" min-width="250">
                <template slot-scope="scope">
                    <span>{{ scope.row.title || "未知" }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="likeCount" label="点赞数" align="center" min-width="100">
                <template slot-scope="scope">
                    <span>{{ (scope.row.likeCount || 0) | numFormat }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="playCount" label="总播放量" align="center" min-width="100">
                <template slot-scope="scope">
                    <span>{{ (scope.row.playCount || 0) | numFormat }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="effectivePlayCount" label="有效播放量" align="center" min-width="110">
                <template slot-scope="scope">
                    <span>{{ (scope.row.effectivePlayCount || 0) | numFormat }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="hot" label="视频热度值" align="center" min-width="100">
                <template slot-scope="scope">
                    <span>{{ (scope.row.hot || 0) | numFormat }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="reviewAt" label="审核时间" align="center" width="160">
                <template slot-scope="scope">
                    <span>{{ scope.row.reviewAt | changeDate }}</span>
                </template>
            </el-table-column>
            <el-table-column label="审核结果" align="center" width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.status === 1">审核通过</span>
                    <span v-if="scope.row.status === 2">未通过</span>
                    <span v-if="scope.row.status === 5">下架</span>
                </template>
            </el-table-column>

        </el-table>
        <!--分页组件-->
        <div class="page">
            <el-pagination :page-sizes="[10, 25, 50, 100]" :current-page="params.pageNumber"
                :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" v-if="total > 10" :total="total" background
                @size-change="changeSize" @current-change="changeCurrent">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
    import API from "@/api";
    export default {
        data() {
            return {
                isQueryHot: false,
                loading: false,
                params: {
                    pageNumber: 1,
                    pageSize: 10,
                    keyword: "",
                },
                total: 0,
                tableData: [],
            }
        },
        created() {},
        methods: {
            // 查询视频列表
            async getVideoList() {
                this.loading = true;
                let ret = await API.queryVidHot(this.params);
                if (ret && ret.code == 200) {
                    this.tableData = ret.data.list;
                    this.total = ret.data.total;
                }
                this.loading = false;
            },
            // 打开弹窗
            open() {
                this.isQueryHot = true;
                this.getVideoList();
            },
            handleClose() {
                this.params.pageNumber = 1;
                this.params.pageSize = 10;
                this.tableData = [];
                this.total = 0;
                this.isQueryHot = false;
            },
            // 分页条数改变回调
            changeSize(size) {
                this.params.pageSize = size;
                this.getVideoList();
            },
            // 分页页码改变回调
            changeCurrent(number) {
                this.params.pageNumber = number;
                this.getVideoList();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .page {
        display: inline-block;
        // float: right;
    }
</style>